import { IconButton } from "@mui/material";
import AgGrid from "../../../UI/AgGrid";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { useDisable } from "../../../../hooks/use-disable";
import { useFormContext, useWatch } from "react-hook-form";
import { IPromotion } from "../../../../types/Marketing/Promotion";

type Props = {
  rowData: any[];
  onRemoveHandler: (index: number) => void;
};

const CustomerSpecificTable = ({ rowData, onRemoveHandler }: Props) => {
  const gridRef = useRef<AgGridReact>();
  const { t } = useTranslation();
  const [disabled] = useDisable();

  const { control } = useFormContext<IPromotion>();
  const watchIsApplied = useWatch({ control, name: "is_applied" });
  const isApplied = Boolean(watchIsApplied);

  const columnDefs: ColDef[] = [
    {
      field: "unique_id",
      headerName: t("contact.unique_id"),
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "taxpayer_id",
      headerName: t("contact.info.taxpayer_id"),
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "full_name",
      headerName: `${t("contact.info.brand_name")}/ชื่อ นามสกุล`,
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    ...(disabled || isApplied
      ? []
      : [
          {
            field: "",
            filter: false,
            sortable: false,
            width: 50,
            cellStyle: {
              display: "flex",
              justifyContent: "center",
            },
            cellRenderer: (params: ICellRendererParams) => {
              if (params.data) {
                return (
                  <IconButton
                    onClick={() => onRemoveHandler(params.rowIndex)}
                    size="small"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                );
              }
            },
          },
        ]),
  ];
  return (
    <AgGrid
      ref={gridRef}
      columnDefs={columnDefs}
      rowData={rowData}
      height={300}
    />
  );
};

export default CustomerSpecificTable;
